// extracted by mini-css-extract-plugin
export default {"icon":"xQXuh","bannerIcon":"_1FQ7q","scopeIcon":"_1U_Pw","metricIcon":"_2lOod"};